export default class Tournament {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/struct/Tournament.ts